import { API_URL } from "../config/connect";

/**
 * Fetch recommended announcements for the main page.
 * Uses cookies (withCredentials) so that backend can read `agro_prefs`.
 */
export const getRecommendedAnnouncements = async ({ page = 1, limit = 10 } = {}) => {
    try {
        const accessToken = localStorage.getItem('access_token');

        const headers = {
            Accept: 'application/json',
        };

        if (accessToken) {
            headers.Authorization = `Bearer ${accessToken}`;
        }

        const queryParams = new URLSearchParams();
        queryParams.append('page', String(page));
        queryParams.append('limit', String(limit));

        // Use production API base URL; backend route must exist in prod.
        const normalizedBaseUrl = API_URL.replace(/\/+$/, "");
        const url = `${normalizedBaseUrl}/api/v1/announcements/recommended?${queryParams.toString()}`;

        if (process.env.NODE_ENV === 'development') {
            console.debug('getRecommendedAnnouncements: GET', url);
        }

        const response = await fetch(url, {
            method: 'GET',
            headers,
            credentials: 'include',
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status} - ${response.statusText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching recommended announcements:', error);
        throw error;
    }
};

